import {Route} from '@angular/router';
import {
  AssetInformationComponent
} from '@app/features/analysis-refactor/pages/analysis-configuration/pages/asset-information1/asset-information.component';

export const assetInformationRoutes: Route[] = [
  {
    path: '',
    component : AssetInformationComponent,
    children: [
      {
        path: 'geospatial-regulations',
        // loadComponent: () => import('@app/features/analysis-refactor/components/pages/asset-information/geospatial-regulations/geospatial-regulations')
        loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/pages/asset-information1/pages/geospatial-regulations/geospatial-regulations.component')
          .then(m => m.GeospatialRegulationsComponent)
      },
      {
        path: 'infrastructure-sustainability',
        loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/pages/asset-information1/pages/infrastructure-sustainability/infrastructure-sustainability.component')
          .then(m => m.InfrastructureSustainabilityComponent)
      }
    ]
  }
]
